import apiRequest from '../../utils/bccampusGraphQLRequest';
import GetQuestionsByPageQuery from '../queries/SupportQuestions.graphql';

const read = async (page) => {
    return await getByPage(page);
}

const getByPage = async (page) => {
    const variables = {
        page: page,
    };
    const result = await apiRequest(GetQuestionsByPageQuery, variables);
    return result.supportCategories;
}

const supportQuestionsRepository = { read };

export { read }
export default supportQuestionsRepository
